import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { usePricesApi } from 'pages/hooks/usePricesApi';

import { Page } from 'components/page/Page';

import { PairsGrid } from './components/PairsGrid';

export default () => {
  const { search } = useLocation();
  const { getData } = usePricesApi();
  useEffect(() => {
    getData();
  }, [getData, search]);
  return (
    <Page title="Pairs">
      <PairsGrid />
    </Page>
  );
};
